<template>
  <div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>标题
        </div>
        <div class="pl16">
          <a-input class="input-style-2" type="text" :maxLength="30" placeholder="请输入标题名称"
            v-model="info.zpname"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'" />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>案例选题
        </div>
        <div class="pl16">
           <a-select ref="select" v-model="info.name"
              class="com-aspect" style="min-width:280px;" placeholder="请选择案例选题">
              <a-select-option :value="item.label" :key="item.label" :data-key="item.key"
                :data-index="index" v-for="(item, index) in xtlist">
                {{ item.label }}
              </a-select-option>
            </a-select>
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>案例联系人
        </div>
        <div class="pl16">
          <a-input class="input-style-2" type="text" :maxLength="30" placeholder="请输入案例联系人"
            v-model="info.principals"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'" />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>联系电话
        </div>
        <div class="pl16">
          <a-input class="input-style-2" type="text" :maxLength="11"
            onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入联系电话" v-model="info.phone"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'" />
        </div>
      </div>
    </div>
    <!-- <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span>团队类型
        </div>
        <div class="pl16">
          <a-radio-group v-model="info.teamType">
            <a-radio value="teacher">教师团队</a-radio>
            <a-radio value="student">学生团队</a-radio>
          </a-radio-group>
        </div>
      </div>
    </div> -->
    <!-- <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f"></span>团队成员
        </div>
        <div class="pl16">
          <template v-for="(tag) in tags">
            <a-tag class="com-aspect text-center" :key="tag" :closable="true"
              @close="() => handleClose(tag)">
              {{ tag }}
            </a-tag>
          </template>
          <a-input v-if="inputVisible" ref="input" type="text" size="small"
            :style="{ width: '150px' }" :value="inputValue" @change="handleInputChange"
            @blur="handleInputConfirm" @keyup.enter="handleInputConfirm" :maxLength="30"
            class="com-aspect text-left" />
          <a-tag v-else-if="tags.length < 20" style="
              background: #fff;
              borderstyle: dashed;
              display: inline-block;
              width: 150px;
            " @click="showInput" class="com-aspect text-center">
            <a-icon type="plus" />添加成员
          </a-tag>
        </div>
      </div>
    </div> -->

    <div class="submit-btn" @click="goStep">下 一 步</div>
  </div>
</template>

<script>
import { checkName,getMajor1,getMajor2,getMajor3 } from '@/api/index';
import { getAction } from '@/api/index';
export default {
  name: '',
  components: {},
  props: {
    editInfoStep1: {
      type: Object,
    },
  },
  data() {
    return {
      list1: [
        {
          key: 1,
          value: '中职思政课程组',
        },
        {
          key: 2,
          value: '中职公共基础课程组',
        },
        {
          key: 3,
          value: '中职专业技能课程一组',
        },
        {
          key: 4,
          value: '中职专业技能课程二组',
        },
      ],
      list2: [
        {
          key: 5,
          value: '高职思政课程组',
        },
        {
          key: 6,
          value: '高职公共基础课程组',
        },
        {
          key: 7,
          value: '高职专业课程一组',
        },
        {
          key: 8,
          value: '高职专业课程二组',
        },
      ],
      schoolType: Number(
        JSON.parse(sessionStorage.getItem('userInfo')).schoolType
      ),
      info: {
        name: '',
        zpname:'',
        levelTypeText: this.fSetLevelTypeText(),
        levelType: this.fSetLevelType(),
        teamType: 'teacher',
        major1:'',
        major1_dictText:"",
        major2:'',
        major2_dictText:"",
        major3:'',
        major3_dictText:"",
        phone: '',
        principals: '',
        teams: '',
      },
      major1Opt:'',
      major2Opt:'',
      major3Opt:'',
      levelTypeText: '',
      tags: [],
      inputVisible: false,
      inputValue: '',
      id:'',
       xtlist:[],
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    this.getxt();
//	console.log(this.$route.params.id);
    if (this.$route.params) {
      this.$nextTick(() => {
        this.info.major1 = this.$route.params.major1;
        this.info.major2 = this.$route.params.major2;
        this.info.major3 = this.$route.params.major3;
        
        this.info.major1_dictText = this.$route.params.major1_dictText;
        this.info.major2_dictText = this.$route.params.major2_dictText;
        this.info.major3_dictText = this.$route.params.major3_dictText;
        this.info.zpname = this.$route.params.zpname;
         this.info.name = this.$route.params.name;
        // this.info.teams = this.$route.params.teams;
//      this.levelTypeText = this.getGroupList(this.schoolType).filter(
//        (item) => {
//          return item.key == this.$route.params.levelType;
//        }
//      );
//      console.log(this.levelTypeText);
//      this.editMajor();
//      if (this.levelTypeText.length <= 0) return;
//      this.$set(this.info, 'levelTypeText', this.levelTypeText[0].value);
        // if (this.$route.params.teams && this.$route.params.teams != '') {
        //   this.tags = this.$route.params.teams.split(',');
        // }
//      console.log(this.tags);
      });

    }
    if(this.$route.params.id!='' && this.$route.params.id!=null && this.$route.params.id!=undefined){
      sessionStorage.setItem(
	      'qbsj',
	      JSON.stringify(this.$route.params)
	    );
    }
    let oldInfo = JSON.parse(
      sessionStorage.getItem(`step${this.$store.state.user.id}`)
    );
//  console.log(oldInfo);
    if (oldInfo) {
      this.$nextTick(()=>{
        this.info.zpname = oldInfo.zpname;
         this.info.name = oldInfo.name;
        this.info.major1 = oldInfo.major1;
        this.info.major2 = oldInfo.major2;
        this.info.major3 = oldInfo.major3;
        this.info.major1_dictText = oldInfo.major1_dictText;
        this.info.major2_dictText = oldInfo.major2_dictText;
        this.info.major3_dictText = oldInfo.major3_dictText;
        
      })
     
      // this.info.name = oldInfo.name;
      this.info.phone = oldInfo.phone;
      this.info.principals = oldInfo.principals;
      // this.info.teams = oldInfo.teams;
      this.info.levelType = oldInfo.levelType;
      this.id=oldInfo.id;
//    this.info.levelTypeText = oldInfo.levelTypeText;
      // if (oldInfo.teams && oldInfo.teams != '') {
      //   this.tags = oldInfo.teams.split(',');
      // }
      
    }
    if(sessionStorage.getItem('qbsj')!=undefined){
    	 let sjInfo=JSON.parse(sessionStorage.getItem('qbsj'));
//  	 console.log(sjInfo);
    	 this.$nextTick(() => {
    	 this.info.zpname = sjInfo.zpname;
        this.info.name = sjInfo.name;
    	 this.info.phone = sjInfo.phone;
       this.info.principals = sjInfo.principals;
      //  this.info.teams = sjInfo.teams;
       this.id=sjInfo.id;
      //  if (sjInfo.teams && sjInfo.teams != '') {
      //   this.tags = sjInfo.teams.split(',');
      //  }
      });
    }
//  this.getMajorD();
  },
  methods: {
     getxt(){
      getAction("/sys/ng-alain/getDictItems/example_subject", {}).then((res) => {
        this.xtlist = res;
      });
    },
    getMajorD(){
      getMajor1().then(res=>{
        if(res.success){
          this.major1Opt = res.result;
        }
      }).then(err=>{
        console.log(err)
      }) 
    },
    editMajor(){
      getMajor2({categoryId:this.info.major1}).then(res=>{
        this.major2Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
      getMajor3({subclassId:this.info.major2}).then(res=>{
        this.major3Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
    },
    major1Change(value,option){
      this.info.major1 = option.data.attrs['data-key'];
      this.info.major1_dictText = option.data.key
      this.info.major2_dictText = ""
      this.info.major3_dictText = ""
      this.info.major2 = ""
      this.info.major3 = ""

      getMajor2({categoryId:this.info.major1}).then(res=>{
        this.major2Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
    },
    major2Change(value,option){
      this.info.major2 = option.data.attrs['data-key'];
      // this.$set(this.info,'major3',' ')
      this.info.major2_dictText = option.data.key
      this.info.major3_dictText = ""
      getMajor3({subclassId:this.info.major2}).then(res=>{
        this.major3Opt = res.result;
      }).then(err=>{
        console.log(err)
      })
      this.info.major3 = ""
    },
    major3Change(value,option){
      this.info.major3 = option.data.attrs['data-key'];
      this.info.major3_dictText = option.data.key;
      this.$forceUpdate();
//    console.log(this.info.major3)
    },
    fSetLevelTypeText(){
      var schoolType = JSON.parse(sessionStorage.getItem('userInfo')).schoolType;
      if(schoolType == 1){
        return '中职思政课程组'
      }else if(schoolType == 2){
        return '高职思政课程组'
      }
    },
    fSetLevelType(){
      var schoolType = JSON.parse(sessionStorage.getItem('userInfo')).schoolType;
      if(schoolType == 1){
        return 1
      }else if(schoolType == 2){
        return 5
      }
    },
    handleClose(removedTag) {
//    console.log(removedTag,'removedTag')
      const tags = this.tags.filter((tag) => tag !== removedTag);
      // console.log(tags,'tags')
      this.tags = tags;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      if (inputValue.length > 30) {
        return false;
      }
      let tags = this.tags;
      if (tags.length >= 20) {
        this.$message.warn('团队成员不能超过个20成员！');
        return false;
      }
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      });
    },
    getGroupList(schoolType) {
      if (schoolType == 1) return this.list1;
      return this.list2;
    },
    handleChange(value, option) {
      this.info.levelType = option.data.attrs['data-key'];
      this.info.major1 = "";
      this.info.major1_dictText = "";
      this.info.major2 = "";
      this.info.major2_dictText = "";
      this.info.major3 = "";
      this.info.major3_dictText = "";
//    console.log(this.info.levelType,'11111');
    },
    goStep() {
//    if (
//      (this.info && this.info.name.trim() === '') ||
//      this.info.name == undefined
//    ) {
//      this.$message.info('请填写课程名称');
//      return false;
//    }
      if ( this.info && (this.info.zpname == undefined || this.info.zpname == null || this.info.zpname.trim() === '') ){
        this.$message.info('请填写标题名称');
        return false;
      }
      if ( this.info && (this.info.name == undefined || this.info.name == null || this.info.name=== '') ){
        this.$message.info('请选择案例选题');
        return false;
      }

//    if(this.info.levelType == 3 || this.info.levelType == 4 || this.info.levelType == 7 || this.info.levelType == 8){
//      if ( this.info.major1 == undefined || this.info.major1 == "") {
//        this.$message.info('请选择专业大类');
//        return false;
//      }
//      if ( this.info.major2 == undefined || this.info.major2 == "") {
//        this.$message.info('请选择专业子类');
//        return false;
//      }
//      if ( this.info.major3 == undefined || this.info.major3 == "") {
//        this.$message.info('请选择专业分类');
//        return false;
//      }
//    }
//    if(this.info.major1){
//      if(this.info.major2 == undefined ||  this.info.major2 == ""  || this.info.major2 == null){
//        this.$message.info('请选择专业子类');
//        return false;
//      }
//    }
//    if(this.info.major2){
//      if(this.info.major3 == undefined ||  this.info.major3 == ""  || this.info.major3 == null){
//        this.$message.info('请选择专业分类');
//        return false;
//      }
//    }
      if (
        (this.info && this.info.principals.trim() === '') ||
        this.info.principals == undefined
      ) {
        this.$message.info('请填写案例联系人');
        return false;
      }
      if (
        (this.info && this.info.phone === '') ||
        this.info.phone == undefined
      ) {
        this.$message.info('请输入手机号');
        return false;
      } else {
        var telStr = /^[1]([3-9])[0-9]{9}$/;
        if (!telStr.test(this.info.phone)) {
          this.$message.info('请输入正确格式手机号');
          return false;
        }
      }
      // if(this.tags.length=='0'){
      // 	 this.$message.info('请上传团队成员');
      // 	 return false;
      // }
      // 校验重复
      let applyType=1;
//    console.log(this.id);
      checkName({
        zpname: this.info.zpname,
        id: this.$route.params.id?this.$route.params.id:this.id,
        applyType: applyType,
      }).then((res) => {
        if (res.message == '信息可用') {
          // this.info.teams = this.tags.join(',');
//        console.log(this.info)
          if(this.info.levelType == 1 ||this.info.levelType == 2  ||this.info.levelType == 5  || this.info.levelType == 6  ){
            this.info.major1 = "";
            this.info.major2 = "";
            this.info.major3 = "";
          }
          this.$emit('goStep', this.info);
        } else {
          this.$message.info(res.message);
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.mt30 {
  margin-top: 20px;
}
.main-text-style {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}
.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 38px;
  text-align: center;
  background: #9A0B00;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.com-aspect {
  min-width: 88px;
  height: 54px;
  font-size: 16px;
  line-height: 54px;
  position: relative;
  padding-right: 24px;
  /deep/ .anticon-close{
    position: absolute;
    top: 50%;
    right: 10px;
    transform:translateY(-50%);
  }
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
/deep/.com-aspect.ant-select > div {
  width: 100%;
  height: 100%;
  .ant-select-selection__rendered {
    font-size: 18px;
    line-height: 54px;
  }
}
</style>
